module.exports = __webpack_public_path__ + "img/honor.39c3f73a.png";